import {AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {Utils} from "../utils/utils";

export class DbValidators {

  public static confirmPassword(control: FormControl): ValidationErrors|null {
    let passwordFc: FormControl = control.parent ? control.parent.controls['password'] : null;

    return !passwordFc || control.value === passwordFc.value ? null : {
      confirmPassword: {
        valid: false
      }
    };
  }

  public static card(control: FormControl): ValidationErrors|null {
    let isValidCard: boolean = !!Utils.detectCardType(control.value);
    return isValidCard ? null : {
      card: {
        valid: false
      }
    };
  }


  public static trim(control: FormControl): ValidationErrors|null {
    const trimmedValue: string = control.value && control.value.trim();

    if (control.value !== trimmedValue) {
      control.setValue(trimmedValue);
    }

    return null;
  }

  public static trimStart(control: FormControl): ValidationErrors|null {
    const trimmedValue: string = control.value && control.value.trimStart();

    if (control.value !== trimmedValue) {
      control.setValue(trimmedValue);
    }

    return null;
  }


  public static sameDomain(control: FormControl): ValidationErrors|null {
    const homeUrl: FormControl = control.parent ? control.parent.controls['websiteUrl'] : null;

    const _homeUrl = homeUrl && homeUrl.value.replace('http://', '').replace('https://', '')
      .replace('www.', '').split(/[/?#]/)[0];

    const newUrl = control.value.replace('http://', '').replace('https://', '')
      .replace('www.', '').split(/[/?#]/)[0];

    const controlName = DbValidators.getControlName(control);
    const _control = {};
    _control[controlName] = {valid: false};
    return !homeUrl || newUrl === _homeUrl ? null : _control;
  }
  public static getControlName(c: AbstractControl): string | null {
    const formGroup = c && c.parent && c.parent.controls;
    return formGroup && Object.keys(formGroup).find(name => c === formGroup[name]) || null;
  }

  public static maxQuantity(quantity: number): ValidatorFn {
    return (control: FormControl): ValidationErrors|null => {
      const items = control.value.split(',').map(i => i.trim());
      return items.length >= quantity ? {'exceededLimit' : quantity} : null;
    };
  }

  public static duplicate(control: FormControl): ValidationErrors|null {
    const items = control.value.split(',').map(i => i.trim());
    return new Set(items).size !== items.length ? {'duplicate': true} : null;
  }

  public static hasValue(value: number | string): ValidatorFn {
    return (control: FormControl): ValidationErrors|null => {
      const items = control.value.split(',').map(i => i.trim());
      return new Set(items).has(value) ? {'hasValue': true} : null;
    };
  }

  public static commaSepEmail(control: FormControl): ValidationErrors | null {
    const emails = control.value.split(',').reduce((acc, item) => {
      if (item.trim()) {
        acc.push(item.trim());
      }
      return acc;
    }, []);
    const regExp = new RegExp(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/);
    const forbidden = emails.some(email => Validators.email(new FormControl(email)) || !regExp.test(email));
    return forbidden ? {'toAddress': {value: control.value}} : null;
  }
}
